import { Object3D } from 'three';
import type { Vec3 } from '../geo/types';
import type { HarbourTrade } from '../world/harbour/tradePlan';
import type { CargoOwner, TradeStage, TradeTimetable } from '../world/harbour/tradeMotion';

export interface HarbourDiagnostics {
  readonly stage: TradeStage;
  readonly owner: CargoOwner;
  readonly active: boolean;
  readonly shipId: string;
  readonly quay: readonly [number, number];
  readonly scale: readonly [number, number];
  readonly cargo: Vec3;
  readonly lighter: Vec3;
  readonly cart: Vec3;
  readonly weighingAngle: number;
  readonly timetable: TradeTimetable;
}

/** Inspect actual rendered carriers, so the delivery can be checked independently of its planner. */
export function harbourDiagnostics(root: Object3D): HarbourDiagnostics | null {
  const trade = root.getObjectByName('harbour-trade');
  const state = trade?.userData['trade'] as
    | {
        plan: HarbourTrade;
        timetable: TradeTimetable;
        stage: TradeStage;
        owner: CargoOwner;
        active: boolean;
      }
    | undefined;
  if (!trade || !state) return null;
  const at = (name: string): Vec3 => {
    const object = trade.getObjectByName(name);
    if (!object) throw new Error(`Harbour delivery has no rendered ${name}`);
    object.updateWorldMatrix(true, false);
    const m = object.matrixWorld.elements;
    return [m[12], m[13], m[14]];
  };
  return {
    stage: state.stage,
    owner: state.owner,
    active: state.active,
    shipId: state.plan.ship.id,
    quay: state.plan.quay,
    scale: state.plan.scale,
    cargo: at('trade-cargo'),
    lighter: at('working-lighter'),
    cart: at('trade-handcart'),
    weighingAngle: trade.getObjectByName('weighing-beam')!.rotation.z,
    timetable: state.timetable,
  };
}
